<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">Çekiliş Sayfası</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <router-link tag="li" to="/" class="breadcrumb-item"
                ><a>Anasayfa</a></router-link
              >
              <li class="breadcrumb-item active">Çekiliş Sayfası</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header card-title">
                Çekiliş Sayfası
                <button
                  class="btn btn-primary btn-sm float-right"
                  @click="resetModal"
                  v-if="LoggedInUserIsAdmin === 'true'"
                >
                  <i class="fas fa-plus"> </i> Add Manual Ticket
                </button>
              </div>
              <div class="card-body">
                <div class="overlay-wrapper">
                  <div class="overlay" v-if="overlay">
                    <i class="fas fa-3x fa-spinner fa-spin"></i>
                  </div>
                  <div class="row">
                    <div class="col-xl-2 my-1">
                      <input
                        type="text"
                        placeholder="Müşteri ID"
                        class="form-control form-control-sm"
                        v-model="search.code"
                      />
                    </div>

                    <div class="col-xl-2 my-1">
                      <button
                        class="btn btn-info btn-sm w-100"
                        @click="pagination"
                      >
                        <i class="fas fa-search"></i> Filtrele
                      </button>
                    </div>
                    <div class="col-xl-2 my-1">
                      <button
                        class="btn btn-danger btn-sm w-100"
                        @click="reset"
                      >
                        Temizle
                      </button>
                    </div>
                    <div class="col-xl-2 my-1"></div>

                    <div class="col-xl-2 my-1">
                      <button
                        class="btn btn-outline-success btn-sm w-100"
                        @click="exportToExcel"
                      >
                        <i class="fas fa-file"></i> Export to Excel
                      </button>
                    </div>
                  </div>
                  <br />
                  <div class="table-responsive">
                    <table class="table table-striped projects">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>müşteri kodu</th>
                          <!-- <th>İşlem kimliği</th> -->
                          <th>Çekiliş tipi</th>
                          <th>eklenme tarihi</th>
                          <!-- <th>tarafından eklendi</th> -->
                          <th>miktar</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(data, index) in datas" :key="index">
                          <td>{{ ++index + (page - 1) * count }}</td>
                          <td>
                            {{ data.customer_code }}
                          </td>
                          <!-- <td>
                            {{ data.transaction_id }}
                          </td> -->
                          <!-- <td>
                            <template
                              v-if="
                                data.transaction_id.split(',').filter(Boolean)
                                  .length <= 2
                              "
                            >
                              {{ data.transaction_id }}
                            </template>
                            <template v-else>
                              <div>
                                {{
                                  data.transaction_id
                                    .split(",")
                                    .slice(0, 2)
                                    .join(", ")
                                    .replace(/,\s*$/, "")
                                }}
                                <button
                                  class="btn btn-outline-info btn-sm"
                                  data-toggle="modal"
                                  data-target="#view_transaction_ids"
                                  @click="openModal(data.transaction_id)"
                                >
                                  Show More
                                </button>
                              </div>
                            </template>
                          </td> -->

                          <td>
                            {{ data.cekilis_type }}
                          </td>
                          <td>
                            {{ data.add_date | DateFormat }}
                          </td>
                          <!-- <td>{{ data.add_user }}</td> -->
                          <td>
                            {{ data.amount }}
                          </td>
                        </tr>
                        <tr>
                          <td
                            v-if="datas.length == 0"
                            colspan="6"
                            class="text-center"
                          >
                            Kayıt Bulunamadı
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <pagination
                  v-model="page"
                  :records="rows"
                  :per-page="count"
                  @paginate="pagination"
                />
              </div>
            </div>

            <!-- /.card -->
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <div class="modal fade" id="modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              Add Manual Tickets
              {{ data.customer_code ? "Düzenleme" : "Ekleme" }}
            </h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="onSubmit">
              <div class="form-group">
                <label>Müşteri ID</label>
                <textarea
                  v-model="data.customer_code"
                  class="form-control"
                  placeholder="Müşteri ID"
                ></textarea>
              </div>

              <!-- <div class="form-group">
                <label>İşlem kimliği</label>
                <textarea
                  v-model="data.transaction_id"
                  class="form-control"
                  placeholder="İşlem kimliği Arasını virgül(,) ile ayırınız"
                ></textarea>
              </div> -->

              <!-- <div class="form-group">
                <label>Çekiliş tipi</label>
                <textarea
                  v-model="data.cekilis_type"
                  class="form-control"
                  placeholder="Çekiliş tipi"
                  @input="validateInput"
                ></textarea>
                <div v-if="error" class="error-message">{{ error }}</div>
              </div> -->

              <div class="form-group">
                <label>Çekiliş tipi</label>
                <select v-model="data.cekilis_type" class="form-control">
                  <option
                    v-for="type in cekilisTypes"
                    :key="type.type"
                    :value="type.type"
                    >{{ type.type }}</option
                  >
                </select>
              </div>

              <div class="form-group">
                <label>Miktar</label>
                <textarea
                  v-model="data.amount"
                  class="form-control"
                  placeholder="Miktar"
                ></textarea>
              </div>
            </form>
          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              İptal
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="save()"
              :disabled="$v.data.$invalid"
            >
              Kaydet
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div class="modal fade" id="view_transaction_ids">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              Transaction Ids List
            </h4>
          </div>
          <div class="modal-body">
            <ul>
              <li
                v-for="(id, index) in modalTransactionIds.split(',')"
                :key="id"
              >
                {{ index + 1 }}. {{ id.trim() }}
              </li>
            </ul>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      page: 1,
      count: 10,
      rows: 0,
      datas: [],
      cekilisTypes: [],

      auth: this.$store.getters.getModules,
      data: {
        id: 0,
        code: [],
        type: [],
        description: "",
        cekilis_type: "",
        cekilisTypes: []
      },

      overlay: false,
      search: {
        code: "",
        bonus: ""
      },
      LoggedInUserId: localStorage.getItem("id"),
      LoggedInUserIsAdmin: localStorage.getItem("isAdmin"),
      modalVisible: false,
      modalTransactionIds: "",
      error: ""
    };
  },
  validations: {
    data: {
      customer_code: { required },
      cekilis_type: { required }
    }
  },
  methods: {
    validateInput() {
      // Regular expression to match only alphabets
      const regex = /^[a-zA-Z]+$/;

      if (!regex.test(this.data.cekilis_type)) {
        this.error = "Lütfen geçerli tür girin";
      } else if (!this.data.cekilis_type) {
        this.error = "Lütfen bir çekiliş tipi seçin";
      } else {
        this.error = "";
      }
    },

    fetchCekilisTypes() {
      console.log("Fetching cekilisTypes...");
      this.$http
        .get("CustomerTickets/cekilisTypes")
        .then(response => {
          this.cekilisTypes = response.data;
          console.log("CekilisTypes:", this.cekilisTypes);
        })
        .catch(error => {
          console.error("Error fetching cekilisTypes:", error);
        });
    },

    pagination(value) {
      this.getDatas();
      this.getDatas(true);
    },
    reset() {
      this.page = 1;
      this.search = {
        code: "",
        bonus: ""
      };
      this.getDatas();
      this.getDatas(true);
    },
    getDatas(type = false) {
    debugger
      if (!type) this.overlay = true;
      this.$http
        .post("CustomerTickets/ListCustomerTicketsList", {
          code: this.search.code.trim(),
          bonus: this.search.bonus,
          rowNumber: type,
          page: this.page - 1,
          LoggedInUserIsAdmin: this.LoggedInUserIsAdmin,
          LoggedInUserId: this.LoggedInUserId
        })
        .then(response => {
          if (type) this.rows = response.data;
          else {
            this.datas = response.data;
            this.overlay = false;
          }
        });
    },

    exportToExcel() {
      this.overlay = true;
      this.$http
        .post("CustomerTickets/ExportCustomerTicketListToExcel", {
          code: this.search.code.trim(),
          bonus: this.search.bonus
        })
        .then(response => {
          this.overlay = false;
          var bytes = this.base64ToArrayBuffer(response.data);
          let reportName = `_raffle_page_${new Date().toLocaleDateString()}.xlsx`;
          this.saveByteArray(reportName, bytes);
        });
    },
    save() {
      let data = {
        customer_code: this.data.customer_code,
        cekilis_type: this.data.cekilis_type,
        amount: this.data.amount,
        add_user: this.LoggedInUserId
      };
      this.$http
        .post("CustomerTickets/AddOrUpdateCustomerManualTickets", data)
        .then(response => {
          $("#modal").modal("hide");
          toastr.success("Kayıt başarılı.");
          this.getDatas();
          this.getDatas(true);
        });
    },

    resetModal() {
      this.data = {
        id: 0,
        code: [],
        type: [],
        description: ""
      };
      this.$v.$reset();
      $("#modal").modal();
    },
    del(id) {
      Swal.fire({
        title: "Kayıt kalıcı olarak silinecek! Onaylıyor musunuz?",
        showCancelButton: true,
        confirmButtonText: "Evet! Silinsin",
        cancelButtonText: "İptal",
        icon: "question"
      }).then(result => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.$http.get("Blacklist/DeleteBlacklist/" + id).then(response => {
            toastr.success("Kayıt başarıyla silindi.");
            this.getDatas();
          });
        }
      });
    },
    base64ToArrayBuffer(base64) {
      var binary_string = window.atob(base64);
      var len = binary_string.length;
      var bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }
      return bytes.buffer;
    },
    saveByteArray(reportName, byte) {
      var blob = new Blob([byte], { type: "application/octetstream" });
      var isIE = false || !!document.documentMode;
      if (isIE) {
        window.navigator.msSaveBlob(blob, reportName);
      } else {
        var url = window.URL || window.webkitURL;
        var link = url.createObjectURL(blob);
        var a = $("<a />");
        a.attr("download", reportName);
        a.attr("href", link);
        $("body").append(a);
        a[0].click();
        $("body").remove(a);
      }
    },
    openModal(transactionIds) {
      // Split the comma-separated transaction IDs and trim each value
      const idsArray = transactionIds.split(",").map(id => id.trim());

      // Remove the last element if it's an empty string (resulting from the trailing comma)
      if (idsArray[idsArray.length - 1] === "") {
        idsArray.pop();
      }

      // Join the trimmed IDs with commas
      this.modalTransactionIds = idsArray.join(", ");

      // Set modal visibility to true
      this.modalVisible = true;
    },

    closeModal() {
      this.modalVisible = false;
    }
  },
  filters: {
    DateFormat(value) {
      if (!value) return "İşlem Sırasında";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    }
  },
  created() {
    this.getDatas();
    this.getDatas(true);
    this.fetchCekilisTypes();
  },
  watch: {
    "$store.getters.getSite"() {
      this.getDatas();
      this.getDatas(true);
    },
    "$store.getters.getModules"() {
      this.auth = this.$store.getters.getModules;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/RafflePage/RafflePage.vue